import { mapState } from "vuex";
export default {
    computed: {
        ...mapState(["icons"]),
    },
    data() {
        return {}
    },
    methods: {
        gGetIcon(text) {
            if (text == undefined) {
                return "";
            }
            text = text.replaceAll("[mark1]", this.icons.mark1);
            text = text.replaceAll("[mark2]", this.icons.mark2);
            text = text.replaceAll("[mark3]", this.icons.mark3);
            text = text.replaceAll("[mark4]", this.icons.mark4);
            text = text.replaceAll("[mark5]", this.icons.mark5);
            text = text.replaceAll("[mark6]", this.icons.mark6);
            text = text.replaceAll("[mark7]", this.icons.mark7);
            text = text.replaceAll("[mark8]", this.icons.mark8);
            text = text.replaceAll("[mark9]", this.icons.mark9);
            text = text.replaceAll("[mark10]", this.icons.mark10);
            text = text.replaceAll("[icon1]", this.icons.icon1);
            text = text.replaceAll("[icon2]", this.icons.icon2);
            text = text.replaceAll("[icon3]", this.icons.icon3);
            text = text.replaceAll("[icon4]", this.icons.icon4);
            text = text.replaceAll("[icon5]", this.icons.icon5);
            text = text.replaceAll("[icon6]", this.icons.icon6);
            text = text.replaceAll("[icon7]", this.icons.icon7);
            text = text.replaceAll("[icon8]", this.icons.icon8);
            text = text.replaceAll("[icon9]", this.icons.icon9);
            text = text.replaceAll("[icon10]", this.icons.icon10);
            return text;
        },

        gCheckLvData(lv) { //檢查指定階層可選數量
            var sum = this.gSum(lv.options, "Qty");
            if (lv.limit == 0) {
                return true;
            }

            if (sum > lv.limit) {
                return false;
            }

            if (lv.lock) {
                if (sum != lv.limit) {
                    return false;
                }
            }
            return true;
        },
        gCheckS1Data(s1) { //檢查指定群組可選數量(含蓋該群的所有階層)
            if (s1.Groups == undefined) {
                return true;
            }
            for (let i = 0; i < s1.Groups.length; i++) {
                var lv = s1.Groups[i];
                if (!this.gCheckLvData(lv)) {
                    return false;
                }
            }
            return true;
        },
    },
};